export default "__VITE_ASSET__CIMIqYFy__"